export default __webpack_public_path__ + "static/media/3000-gift-voucher.4a668af4.svg";